import axios from "axios";
import { Apis } from "constants/apis";
import { UpdateService } from "types/services";
import { getToken } from "utils/token";

const update: UpdateService = async (payload) => {
    const { data } = await axios.post(Apis.UPDATE_PASSWORD, payload, { headers: { Authorization: getToken() } })
    return data
}
export default update